import { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { formatDateTime } from '../../utils/dateUtils'

export default function VisitorInfoPanel({ visitorMetadata, conversation }) {
  const [expanded, setExpanded] = useState(false)
  const meta = visitorMetadata || {}

  const duration = conversation?.duration_seconds
    ? conversation.duration_seconds < 60
      ? `${conversation.duration_seconds}s`
      : `${Math.floor(conversation.duration_seconds / 60)}m ${conversation.duration_seconds % 60}s`
    : 'N/A'

  const startedAt = conversation?.started_at ? formatDateTime(conversation.started_at) : 'N/A'

  const pageUrl = meta.page_url ? (() => { try { return new URL(meta.page_url).pathname } catch { return meta.page_url } })() : 'N/A'

  return (
    <div className="bg-slate-100/60 rounded-lg">
      {/* Compact summary - always visible */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-3 py-1.5 text-left hover:bg-slate-100 rounded-lg transition-colors"
      >
        <div className="flex items-center gap-3 text-[10px] text-slate-500 min-w-0 overflow-hidden">
          <span><span className="font-semibold text-slate-600">{conversation?.message_count || 0}</span> msgs</span>
          <span className="text-slate-300">|</span>
          <span>{meta.device || 'Unknown'} · {meta.browser || 'Unknown'}</span>
          <span className="text-slate-300">|</span>
          <span>{startedAt} · {duration}</span>
        </div>
        {expanded
          ? <ChevronUpIcon className="h-3 w-3 text-slate-400 flex-shrink-0" />
          : <ChevronDownIcon className="h-3 w-3 text-slate-400 flex-shrink-0" />
        }
      </button>

      {/* Expanded detail - only when toggled */}
      {expanded && (
        <div className="grid grid-cols-4 gap-x-4 gap-y-1.5 px-3 pb-2 pt-1">
          {[
            { label: 'Browser', value: meta.browser || 'Unknown' },
            { label: 'Device', value: meta.device || 'Unknown' },
            { label: 'OS', value: meta.os || 'Unknown' },
            { label: 'Messages', value: conversation?.message_count || 0 },
            { label: 'Started', value: startedAt },
            { label: 'Duration', value: duration },
            { label: 'Page', value: pageUrl },
            { label: 'Referrer', value: meta.referrer || 'Direct' },
          ].map((item) => (
            <div key={item.label} className="min-w-0">
              <div className="text-[9px] text-slate-400 font-medium uppercase tracking-wider">{item.label}</div>
              <div className="text-[10px] text-slate-700 font-medium truncate">{String(item.value)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
